import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // still checking
    return (
      <div
        data-testid="auth-loading"
        className="min-h-[60vh] flex items-center justify-center text-sm text-[color:var(--ink-soft)]"
      >
        Loading your archive…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/app/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
